import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "merchant-service";

export default {
    uploadDocument(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${BASE_SERVICE_URL}/v1/merchant/cms/document/upload`,
                payload,
                {
                    ...auth.getHeader(),
                    "Content-Type": "multipart/form-data"
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    return reject(status, error);
                });
        });
    },
    saveBankDetails(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${BASE_SERVICE_URL}/cms/bank-details/save`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    return reject(status, error);
                });
        });
    },
    getBankDetails() {
        return new Promise((resolve, reject) => {
            api.get(
                `${BASE_SERVICE_URL}/v1/merchant/cms/bank-details/view`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
};
